import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";
import { GetTeacherInformation } from "../../actions/teacherQueries";

function Teacher() {
  const navigate = useNavigate();
  const teacherInfo = GetTeacherInformation();
  useEffect(() => {
    if (teacherInfo.isPending) return;

    if (
      !teacherInfo.data ||
      !teacherInfo.data.programmes ||
      teacherInfo.data.programmes.length === 0
    ) {
      navigate("/teacher/TeacherSupportInfo");
      return;
    }

    let firstProgram = teacherInfo.data.programmes[0];
    navigate(
      "/teacher/programmeview/" + firstProgram.id + "/" + firstProgram.name
    );
  }, [teacherInfo.isPending, navigate, teacherInfo.data]);

  if (teacherInfo.isPending) {
    return <Pacmanloader />;
  }

  return null;
}

export default Teacher;
